import styled from 'styled-components';
import router from 'next/router';

import { useTranslation } from '@hooks';
import { CartSummaryContent } from '@components/cart';
import { NewButton } from '@components/ui';
import { Caption, Caption2 } from '@components/styles/Typography';

const CartSummary = ({
    checkoutSummary,
    currentUser,
    discounts,
    extras,
    subtotal,
    total,
    withoutButton,
    cargoFee,
}) => {
    const { t, useCurrency } = useTranslation();

    const goCheckout = () => {
        if (currentUser) {
            router.push('/checkout');
        } else {
            router.push({
                pathname: '/login',
                query: { cb: '/checkout' },
            });
        }
    };

    return (
        <Container checkoutSummary={checkoutSummary}>
            {!withoutButton && (
                <NewButton
                    type="primary"
                    size="large"
                    content={t('cartConfirm')}
                    disabled={Number(total?.TRY) === 0}
                    handleClick={goCheckout}
                />
            )}
            <CartSummaryWrapper checkoutSummary>
                <SummaryWrapper>
                    <Caption2>{t('cartSummary')}</Caption2>
                </SummaryWrapper>
                <CartSummaryContent
                    cargoFee={cargoFee}
                    discounts={discounts}
                    extras={extras}
                    subtotal={subtotal}
                />
                <TotalPriceWrapper>
                    <CartTotal>{t('cartTotal')}</CartTotal>
                    <CartTotal>{useCurrency(total)}</CartTotal>
                </TotalPriceWrapper>
            </CartSummaryWrapper>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: ${({ checkoutSummary }) =>
        checkoutSummary ? 'relative' : 'sticky'};
    top: 20px;

    button {
        width: 100%;
    }

    @media (max-width: 1024px) {
        display: none;
    }
`;
const CartSummaryWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 240px;
    height: min-content;
    padding: 10px;
    border: ${({ theme }) => `solid 1px ${theme.colors.bgGray10}`};
    margin: 25px 0 20px;
`;
const SummaryWrapper = styled.div`
    margin-bottom: 10px;
`;

const TotalPriceWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: ${({ theme }) => `solid 1px ${theme.colors.bgGray10}`};
`;
export const CartTotal = styled(Caption)`
    padding-top: 10px;
`;

export default CartSummary;
